module.exports = __webpack_public_path__ + "img/horizontal_3_5_5012.1bafce86.png";